// extracted by mini-css-extract-plugin
module.exports = {"cookies":"cookies_form_cookies__1kIUy","link":"cookies_form_link__2XNw0","buttonsContainer":"cookies_form_buttonsContainer__2JLxW","buttonYes":"cookies_form_buttonYes__19bav"};